import { render, staticRenderFns } from "./TestingCenterConsent.vue?vue&type=template&id=104a6173&"
import script from "./TestingCenterConsent.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterConsent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports